import styled from "styled-components";

interface ContainerProps {
  isSelected: boolean;
}

export const Container = styled.button<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) =>
    props.isSelected
      ? "linear-gradient(268.28deg, #06d986 0%, rgba(6, 217, 134, 0) 100%), #4a76fb"
      : "#f2f4f8"};
  color: ${(props) => (props.isSelected ? "white" : "#333333")};
  width: 100%;
  height: 44px;
  padding: 8px 14px 8px 14px;
  gap: 8px;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  border: none;
  outline: none;
  font-weight: 500;
  font-family: Inter;
  font-size: 14px;
  @media (min-width: 1660px) {
    font-size: 16px;
  }
  cursor: pointer;
`;
